import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { currency } from "../../../../../common/services/common.service";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import { selectOrdersQueryItems } from "../../../../../redux/orders/selector";
import { orders } from "../../../../../redux/orders/action";
import moment from "moment";
import PageLoader from "../../../../../components/PageLoader";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";

export const CustomerOrderTracking = () => {
    const { state } = useLocation();
    const { orderId } = state
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { height, width } = useWindowDimensions();
    const orderDetails = useSelector(selectOrdersQueryItems);
    const [order, getOrder] = useState<any>();

    useEffect(() => {
        if (orderId) {
            dispatch(orders.query({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/query-by-tracking-number`, entity: 'orders', jsonData:
                {
                    Records: [
                        {
                            context: {

                            },
                            Message: {
                                TrackingNumber: orderId
                            }
                        }
                    ]
                }
            }))
        }

    }, []);

    useEffect(() => {

        getOrder(orderDetails?.result?.items)
    }, [orderDetails]);

    const convertDate = (date: string) => {
        var gmtDateTime = moment.utc(date, "YYYY-MM-DD HH:mm")
        return gmtDateTime.local().format('YYYY-MMM-DD h:mm A');
    }

    const orderStatus = (id: number) => {
        switch (id) {
            case 10:
                return 'Shipping Not Required';
            case 12:
                return 'Pending';
            case 13:
                return 'Created';
            case 14:
                return 'Serviceable';
            case 16:
                return 'NonServiceable';
            case 17:
                return 'Searching For Agent';
            case 18:
                return 'Packed';
            case 19:
                return 'Agent Assigned';
            case 20:
                return 'Ready To Ship';
            case 22:
                return 'Shipping In Progress';
            case 24:
                return 'At Pickup Location';
            case 30:
                return 'Order PickedUp';
            case 40:
                return 'In Transit';
            case 45:
                return 'At DropLocation';
            case 50:
                return 'Out For Delivery';
            case 60:
                return 'Order Delivered';
            case 70:
                return 'RTO Initiated';
            case 75:
                return 'Partially Returned';
            case 77:
                return 'Liquidated';
            case 79:
                return 'RTO Disposed';
            case 80:
                return 'RTO Delivered';
            case -10:
                return 'Cancelled'
        }
    }

    const paymentMode = (id: any) => {
        switch (id) {
            case 10:
                return 'Cash';
            case 20:
                return 'Online'
            default:
                return 'Cash'
        }

    }

    const logisticsOrderType = (id: any) => {
        switch (id) {
            case 10:
                return 'Parcel';
            case 20:
                return 'Cargo'
            case 30:
                return 'ParcelAndCargo'
            default:
                return 'Parcel'
        }

    }

    const logisticsOrderstatusTimeline = [
        { id: 10, label: 'Pending' },
        { id: 22, label: 'Accepted' },
        { id: 24, label: 'In Progress' },
        { id: 27, label: 'Shipped' },
        { id: 29, label: 'Out For Delivery' },
        { id: 30, label: 'Delivered' },
        { id: 40, label: 'Completed' },
        { id: 42, label: 'RTO Initiated' },
        { id: 50, label: 'RTO Delivered' },
        { id: -10, label: 'Cancelled' },

    ];
    const currentStatusId = order?.Message?.LogisticsOrderStatusId || 0;

    let timelineSteps = [];

    if (currentStatusId === -10) {
        // Show only Pending and Cancelled
        timelineSteps = logisticsOrderstatusTimeline.filter(
            step => step.id === 10 || step.id === -10
        );
    } else {
        // Show steps up to the current status
        const index = logisticsOrderstatusTimeline.findIndex(step => step.id === currentStatusId);
        timelineSteps = index !== -1 ? logisticsOrderstatusTimeline.slice(0, index + 1) : [];
    }

    const AddressBlock = ({ title, data }) => {
        const address = data?.location?.address;
        const contact = data?.contact;

        return (
            <div className="bg-stone-50 border rounded p-4">
                <h4 className="text-lg font-bold text-cyan-600 border-b mb-2">{title}</h4>
                <div className="text-sm space-y-1">
                    <p>Name: {address?.Name}</p>
                    <p>Address: {address?.Locality},</p>
                    <p>{address?.City} - {address?.AreaCode},</p>
                    <p>{address?.State},</p>
                    <p>{address?.Country}</p>
                    <p>Email: {contact?.email}</p>
                    <p>Phone: {contact?.phone}</p>
                </div>
            </div>
        );
    };



    const TimelineItem = ({ label, date }: any) => (
        <li className="mb-6 ms-6">
            <span className="absolute -start-3 w-6 h-6 bg-gray-100 rounded-full ring-8 ring-white flex items-center justify-center">
                <div className="w-2 h-2 bg-gray-500 rounded-full" />
            </span>
            {date && <h4 className="font-semibold">{date}</h4>}
            <p className="text-sm text-gray-600 py-2">{label}</p>
        </li>
    );


    return (
        <>
            {orderDetails?.isLoading ? <div className="flex items-center justify-center mt-40">Loading... </div> :
                <>
                    {width && width < 720 ?
                        //  Start - Mobile View  
                        <section className="bg-gray-50 p-4">
                            <div className="max-w-screen-xl mx-auto px-2 ">
                                <h2 className="text-lg font-semibold text-gray-900 text-center ">
                                    Track the delivery of order: {orderId}
                                </h2>

                                <div className="mt-6 flex flex-col gap-6">
                                    {/* Order Details */}
                                    <div className="bg-white border rounded-lg p-4 w-full">
                                        {order && (
                                            <div className="border-b pb-4">
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Order Type</p>
                                                        <p className="text-sm font-medium text-indigo-600 bg-indigo-50 px-3 py-1 rounded-md inline-block mt-1">
                                                            {logisticsOrderType(order?.Message?.LogisticsOrderTypeId)}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Status</p>
                                                        <p className="text-sm font-medium text-emerald-600  bg-emerald-50 px-3 py-1 rounded-md inline-block mt-1">
                                                            {orderStatus(order?.Message?.ShippingStatusId)}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Total Distance</p>
                                                        <p className="text-sm font-medium text-purple-600 truncate bg-purple-50 px-3 py-1 rounded-md inline-block mt-1">
                                                            {order?.Message?.TotalDistance} Km
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Price</p>
                                                        <p className="text-sm font-medium text-rose-600 bg-rose-50 px-3 py-1 rounded-md inline-block mt-1">
                                                            {currency(order?.Message?.OrderTotal)}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Addresses */}
                                        <div className="grid grid-cols-1 gap-4">
                                            <AddressBlock title="From Address" data={order?.Message?.fulfillments[0]?.start} />
                                            <AddressBlock title="To Address" data={order?.Message?.fulfillments[0]?.end} />
                                        </div>
                                    </div>

                                    {/* Order History */}
                                    <div className="bg-white border rounded-lg p-4 w-full">
                                        <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">Order History</h3>
                                        <ol className="relative border-s border-gray-200 ms-3">
                                            <TimelineItem
                                                label='Order Placed'
                                                date={convertDate(order?.Message?.ShippedDateUtc)}
                                            />
                                            {timelineSteps.map((step) => (
                                                <TimelineItem
                                                    key={step.id}
                                                    label={step.label}
                                                    date={step.id == 30 ? convertDate(order?.Message?.DeliveryDateUtc) : undefined}
                                                />
                                            ))}
                                        </ol>
                                    </div>
                                </div>

                                {/* Back Button */}
                                <div className="flex justify-end pt-6 pb-20">
                                    <button
                                        onClick={() => navigate('/customer/track/order')}
                                        className="bg-gray-800 text-white hover:bg-gray-700 font-semibold px-5 py-2  rounded text-sm "
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                        </section>

                        //  End - Mobile View  
                        :
                        <section className="bg-gray-50 p-8">
                            <div className="max-w-screen-xl mx-auto px-4">
                                <h2 className="text-2xl font-semibold text-gray-900">
                                    Track the delivery of order: {orderId}
                                </h2>

                                <div className="mt-8 flex flex-col lg:flex-row gap-8">
                                    {/* Order Details */}
                                    <div className="bg-white border rounded-lg p-4 w-full ">
                                        {order && (
                                            <div className="border-b pb-4 mb-4 ">
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Order Type</p>
                                                        <p className="text-sm font-medium text-indigo-600 bg-indigo-50 px-3 py-0.5 rounded-md inline-block mt-1">
                                                            {logisticsOrderType(order?.Message?.LogisticsOrderTypeId)}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Status</p>
                                                        <p className="text-sm font-medium text-emerald-600 truncate bg-emerald-50 px-3 py-0.5 rounded-md inline-block mt-1">
                                                            {orderStatus(order?.Message?.ShippingStatusId)}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Total Distance</p>
                                                        <p className="text-sm font-medium text-purple-600 truncate bg-purple-50 px-3 py-0.5 rounded-md inline-block mt-1">
                                                            {order?.Message?.TotalDistance} Km
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-700">Price</p>
                                                        <p className="text-sm font-medium text-rose-600 bg-rose-50 px-3 py-0.5 rounded-md inline-block mt-1">
                                                            {currency(order?.Message?.OrderTotal)}
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        )}

                                        {/* Addresses */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <AddressBlock title="From Address" data={order?.Message?.fulfillments[0]?.start} />
                                            <AddressBlock title="To Address" data={order?.Message?.fulfillments[0]?.end} />
                                        </div>
                                    </div>

                                    {/* Order History */}
                                    <div className="bg-white border rounded-lg p-6 w-full">
                                        <h3 className="text-xl font-semibold text-gray-900 mb-4">Order History</h3>
                                        <ol className="relative border-s border-gray-200 ms-3">
                                            <TimelineItem

                                                label='Order Placed'
                                                date={convertDate(order?.Message?.ShippedDateUtc)}
                                            />
                                            {timelineSteps.map((step, index) => (
                                                <TimelineItem
                                                    key={step.id}
                                                    label={step.label}
                                                    date={step.id == 30 ? convertDate(order?.Message?.DeliveryDateUtc) : undefined}
                                                />
                                            ))}
                                        </ol>
                                    </div>
                                </div>

                                {/* Back Button */}
                                <div className="flex justify-end py-8">
                                    <button
                                        onClick={() => navigate('/customer/track/order')}
                                        className="bg-gray-800 text-white hover:bg-gray-700 font-semibold px-6 py-3 rounded"
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                        </section>

                    }
                </>}
        </>
    )

}